export default "__VITE_ASSET__DO9EC6Be__"